import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { CategoriesComponent } from './categories.component';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CategoriesItemComponent } from './categories-item.component';
import { ItemArrowComponent } from '../../core/components/item-arrow/item-arrow.component';
import { FiltersModule } from 'src/app/filters/filters.module';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: CategoriesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'categories',
        component: CategoriesComponent,
        canActivate: [AuthGuard],
      },
    ]),
    CommonModule,
    CoreModule,
    MatTooltipModule,
    ItemArrowComponent,
    FiltersModule,
  ],
  providers: [],
  declarations: [CategoriesComponent, CategoriesItemComponent],
})
export class CategoriesModule {}
